import { gql } from "@apollo/client";



export const CREATE_ITEM = gql`
mutation CreateItem($input: ItemsInput) {
  createItem(input: $input) {
    status
    message
  }
} `;


export const UPDATE_ITEM = gql`
mutation UpdateItem($id: ID!, $input: ItemsInput) {
  updateItem(_id: $id, input: $input) {
    status
    message
  }
} `;


export const DELETE_ITEM = gql`
mutation DeleteItem($id: ID!) {
  deleteItem(_id: $id) {
    status
    message
  }
}`;


export const GET_ITEM_PAGINATION = gql`
query GetItemPagination(
  $page: Int
  $limit: Int
  $keyword: String
  $pagination: Boolean
) {
  getItemPagination(
    page: $page
    limit: $limit
    keyword: $keyword
    pagination: $pagination
  ) {
    data {
      _id
      itemName
      itemDescription
      incomeType
      createdAt
      updatedAt
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

